import React from 'react';

const CircleLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="34"
    height="34"
    viewBox="0 0 34 34"
  >
    <defs>
      <linearGradient id="1ff07x27ic" x1="8.285%" x2="113.561%" y1="58.969%" y2="23.974%">
        <stop offset="0%" stopColor="#46C2D2" />
        <stop offset="100%" stopColor="#0D92B7" />
      </linearGradient>
      <linearGradient id="ob8rfho5ad" x1="129.413%" x2="34.312%" y1="62.163%" y2="44.983%">
        <stop offset="0%" stopColor="#9ACA3C" />
        <stop offset="100%" stopColor="#6AAB44" />
      </linearGradient>
      <linearGradient id="h1n9yjnrne" x1="50.648%" x2="-63.5%" y1="48.993%" y2="-64.343%">
        <stop offset="0%" stopColor="#9ACA3C" />
        <stop offset="100%" stopColor="#73B544" />
      </linearGradient>
      <circle id="p8kugx2goa" cx="17" cy="17" r="17" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-235 -301) translate(235 301)">
          <mask id="wt67u0ikmb" fill="#fff">
            <use xlinkHref="#p8kugx2goa" />
          </mask>
          <circle cx="17" cy="17" r="16.5" stroke="#1EA0C0" />
          <g fillRule="nonzero" mask="url(#wt67u0ikmb)">
            <g>
              <path
                fill="url(#1ff07x27ic)"
                d="M8.192 12.8s-4.903 2.008-5.362 2.273c-.44.245-.84.552-1.19.913-.311.323-.546.71-.689 1.135-.135.426-.18.875-.133 1.32.04.538.207 1.06.485 1.523.281.444.655.822 1.095 1.108.318.207.655.384 1.006.528-1.615-1.454 3.956-3.248 3.956-3.248s4.468-1.576 5.868-2.123c.741-.289 1.292-.788 1.15-1.341-.31-1.19-6.186-2.088-6.186-2.088z"
                transform="translate(9 6)"
              />
              <path
                fill="url(#ob8rfho5ad)"
                d="M15.975 11.86c-.055-.616-.22-1.136-.488-1.545-.26-.397-.6-.733-.995-.985-.402-.252-.836-.444-1.29-.568-.432-.123-.895-.237-1.368-.344L6.66 7.2s-5.584 1.855-3.966 3.358c.183.08.372.157.573.228.665.226 1.34.413 2.025.56 0 0 11.815 1.445 9.038 3.854.34-.199.65-.449.917-.742.29-.328.505-.72.626-1.146.122-.473.156-.966.102-1.452z"
                transform="translate(9 6)"
              />
              <path
                fill="url(#h1n9yjnrne)"
                d="M15.188 2.08c-.058-.636-.396-1.218-.928-1.597-.266-.186-.567-.32-.886-.396-.35-.082-.712-.107-1.07-.071-.413.042-.814.152-1.188.325-.337.152-.66.292-.955.414L3.774 3.234c-.588.216-1.158.473-1.706.77-.448.24-.856.541-1.213.895C.54 5.215.3 5.595.153 6.011c-.137.418-.182.858-.135 1.293.042.528.211 1.04.495 1.494.286.434.666.804 1.114 1.085.324.203.667.376 1.024.517-1.646-1.424 4.03-3.182 4.03-3.182l5.976-2.08c.356-.112.699-.262 1.02-.447.313-.178.595-.402.836-.663.232-.257.414-.553.535-.874.129-.343.177-.71.14-1.074z"
                transform="translate(9 6)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CircleLogo;
